import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LEARN_PYTHON_PATH } from "../../learn/paths";

// Public registration now happens on the Monday.com form (opens in a new tab).
const REGISTER_URL =
  process.env.REACT_APP_REGISTER_URL || "https://wkf.ms/3V2FTWZ";

const DonateModal = ({ onClose }) => {
  const [copied, setCopied] = useState("");

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(""), 2000);
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[60]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-md w-full shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-t-2xl p-6 text-white text-center">
          <svg
            className="w-10 h-10 mx-auto mb-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
          <h2 className="text-xl font-bold">Support YATA</h2>
          <p className="text-orange-100 text-sm mt-1">
            Help us provide free tech education to young Africans
          </p>
        </div>

        <div className="p-6 space-y-5">
          {/* Bank Transfer */}
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
              Bank Transfer
            </h3>
            <div className="bg-gray-50 rounded-xl p-4 space-y-2 text-sm">
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Bank</span>
                <span className="font-medium text-gray-900">Standard Bank</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Account Name</span>
                <span className="font-medium text-gray-900">
                  Young Africans Technology
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Account No.</span>
                <div className="flex items-center gap-2">
                  <span className="font-medium text-gray-900">10204346205</span>
                  <button
                    onClick={() => copyToClipboard("10204346205", "account")}
                    className="text-blue-600 hover:text-blue-700"
                    title="Copy"
                  >
                    {copied === "account" ? (
                      <svg
                        className="w-4 h-4 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Account Type</span>
                <span className="font-medium text-gray-900">
                  Current Account
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Branch</span>
                <span className="font-medium text-gray-900">Johannesburg</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Branch Code</span>
                <span className="font-medium text-gray-900">000205</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Electronic Branch Code</span>
                <span className="font-medium text-gray-900">051001</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Swift Code</span>
                <span className="font-medium text-gray-900">SBZAZAJJ</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-500">Reference</span>
                <span className="font-medium text-gray-900">YATA Donation</span>
              </div>
            </div>
          </div>

          {/* PayPal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
              PayPal
            </h3>
            <a
              href="http://paypal.me/youngafricanstech"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full py-3 bg-[#0070ba] hover:bg-[#005ea6] text-white font-medium rounded-xl transition-colors"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.076 21.337H2.47a.641.641 0 01-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797H9.603c-.564 0-1.04.408-1.13.964L7.076 21.337z" />
              </svg>
              Donate with PayPal
            </a>
            <div className="flex justify-between items-center bg-gray-50 rounded-xl p-3 mt-2 text-sm">
              <span className="text-gray-500">PayPal Email</span>
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900">
                  payment@youngafricanstech.org
                </span>
                <button
                  onClick={() =>
                    copyToClipboard("payment@youngafricanstech.org", "paypal")
                  }
                  className="text-blue-600 hover:text-blue-700"
                  title="Copy"
                >
                  {copied === "paypal" ? (
                    <svg
                      className="w-4 h-4 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-400 text-center">
            Every contribution helps us keep education free for young Africans.
          </p>
        </div>

        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-xl transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDonate, setShowDonate] = useState(false);
  const location = useLocation();
  const inLearnPython = location.pathname.startsWith(LEARN_PYTHON_PATH);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Courses", path: "/courses" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path) => {
    return path === location.pathname;
  };

  return (
    <>
      <header className="bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14">
            {/* Logo + wordmark */}
            <Link to="/" className="flex items-center gap-2.5">
              <img
                src="/images/yata-icon.png"
                alt="YATA logo"
                width="282"
                height="256"
                className="h-9 w-auto"
              />
              <span className="flex flex-col leading-none">
                <span className="text-2xl font-extrabold tracking-tight text-[#1e2a4a]">
                  YA<span className="text-green-600">T</span>A
                </span>
                <span className="hidden sm:block text-[10px] font-semibold uppercase tracking-[0.15em] text-gray-500 mt-0.5">
                  Through Technology
                </span>
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`px-3.5 xl:px-4 py-2 rounded-lg text-[15px] font-semibold tracking-wide transition-colors ${
                    isActive(link.path)
                      ? "bg-blue-600 text-white"
                      : "text-gray-800 hover:bg-blue-50 hover:text-blue-700"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to={LEARN_PYTHON_PATH}
                className={`ml-2 px-4 py-2 rounded-lg text-[15px] font-semibold tracking-wide text-white transition-colors ${
                  inLearnPython
                    ? "bg-green-700 ring-2 ring-green-300"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                Learning Python
              </Link>
            </div>

            {/* Auth buttons + Donate */}
            <div className="hidden lg:flex items-center gap-3">
              <button
                onClick={() => setShowDonate(true)}
                className="px-4 py-1.5 text-sm font-medium bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
              >
                Donate
              </button>
              <a
                href={REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-1.5 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Register
              </a>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMenuOpen}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t animate-fadeIn">
              <div className="flex flex-col space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.name}
                    to={link.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive(link.path)
                        ? "bg-blue-50 text-blue-700"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {link.name}
                  </Link>
                ))}
                <hr className="my-2" />
                <Link
                  to={LEARN_PYTHON_PATH}
                  onClick={() => setIsMenuOpen(false)}
                  className="mx-3 mb-1 px-3 py-2 text-sm font-semibold bg-green-600 text-white rounded-lg hover:bg-green-700 text-center transition-colors"
                >
                  Learning Python
                </Link>
                <button
                  onClick={() => {
                    setShowDonate(true);
                    setIsMenuOpen(false);
                  }}
                  className="mx-3 px-3 py-2 text-sm font-medium bg-orange-500 text-white rounded-lg hover:bg-orange-600 text-center transition-colors"
                >
                  Donate
                </button>
                <a
                  href={REGISTER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setIsMenuOpen(false)}
                  className="mx-3 mt-1 px-3 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-center"
                >
                  Register
                </a>
              </div>
            </div>
          )}
        </nav>
      </header>

      {showDonate && <DonateModal onClose={() => setShowDonate(false)} />}
    </>
  );
};

export default Header;
